<template>
    <div>
        <img src="../assets/404.jpg"/>
        <h1>抱歉，页面好像去火星了~</h1>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    }
};
</script>
<style>
img {
    display: block;
    margin: 0 auto;
    width: 100%;
}
h1 {
    color: #878d99;
    text-align: center;
}
</style>





// WEBPACK FOOTER //
// src/pages/404.vue